import React from 'react';
import type {SampleErrors} from './types';
import {ChipSamplesTable} from './ChipSamplesTable';
import {ReviewContainer} from './ReviewContainer';

interface AtacReviewProps {
    samples: any[];
    experiment: Readonly<any>;
    errors: SampleErrors;
    reFetchSamples: () => Promise<void>;
    expectedFilenamesBySampleId?: Record<string, string[]>;
}

/**
 * Shows one table of samples for ATAC seq, there are no control vs IP categories.
 */
export const AtacReview: React.FC<AtacReviewProps> = ({samples, experiment, errors, reFetchSamples, expectedFilenamesBySampleId}) => {
    const errorIds = new Set(Object.values(errors).flat());
    return (
        <ReviewContainer>
            <ChipSamplesTable
                samples={samples}
                experiment={experiment}
                errorIds={errorIds}
                onChangeCompleted={reFetchSamples}
                sampleTypeColumn={false}
                expectedFilenamesBySampleId={expectedFilenamesBySampleId}
            />
        </ReviewContainer>
    );
};
